module.exports = __webpack_public_path__ + "img/apu-rumah-solehah.284e2c6d.png";